module.exports = __webpack_public_path__ + "img/pocket side seam.58c53633.png";